import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Paper
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import './portfolio.scss';
import { IRouteMetadata } from 'src/components/layout/appDrawer/types/auth-response.model';

export default function AnalyzePortfolio({
  pagesData
}: {
  pagesData: IRouteMetadata[];
}) {
  // clonng pagesData deeply
  let clonedPagesData: IRouteMetadata[] = JSON.parse(JSON.stringify(pagesData));
  let resData = clonedPagesData.filter(
    (e) => e.parent.name !== 'simulator' && e.parent.name !== 'home'
  );
  resData = resData.map((e) => ({
    parent: e.parent,
    children: e.children.filter((ele) => ele.parent.is_visible === true)
  }));
  console.log('res', resData);

  const [expanded, setExpanded] = useState<string | boolean>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  // ading suffix to icon path
  const suffixValue = '_black';
  const addSuffixToImagePath = (imagePath) =>
    imagePath.replace(/(\.[\w\d]+)$/, `${suffixValue}$1`);

  return (
    <div>
      {resData.map((ele: any) => (
        <Accordion
          expanded={expanded === ele.parent.name}
          onChange={handleChange(ele.parent.name)}
          // sx={{
          //   boxShadow: 'none',
          //   border: 'none'
          // }}
        >
          <AccordionSummary
            expandIcon={
              expanded === ele.parent.name ? (
                <RemoveIcon sx={{ fontSize: '12px' }} />
              ) : (
                <AddIcon sx={{ fontSize: '12px' }} />
              )
            }
            className='accordion-style'
          >
            <div className='section-title'>
              <div>
                <img
                  alt='This is custom icon.'
                  className='icon-div'
                  src={addSuffixToImagePath(
                    `/media/${ele.parent.icon.iconFile}`
                  )}
                />
              </div>
              <div className='title-div'>
                <Typography className='main-title'>
                  {ele.parent.alias}
                </Typography>
                <Typography className='sub-title'>
                  {ele.parent.description}
                </Typography>
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            {ele.children.map(
              (childEle: {
                parent: { [x: string]: string | number | boolean };
              }) => (
                <Paper
                  className='accordian-content'
                  variant='outlined'
                  sx={{ backgroundColor: '#fbfbfb', m: '4px 0px' }}
                >
                  <Link to={childEle.parent.route_url as string}>
                    <div className='flex-aligned-div'>
                      <div className='content-title-div'>
                        <div
                          className='content-main-title'
                          style={{ fontWeight: 'normal' }}
                        >
                          {childEle.parent.alias}
                        </div>
                        <div className='content-sub-title'>
                          {childEle.parent.description}
                        </div>
                      </div>
                      <KeyboardArrowRightIcon sx={{ color: 'black' }} />
                    </div>
                  </Link>
                </Paper>
              )
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}
